import { Key } from "react";
import { NavLink } from "react-router-dom";

function NavbarProps(props: any) {
  const { data, onClick } = props;

  const handleLinkClick = () => {
    if (onClick) {
      onClick();
    }
    window.scroll(0, 0);
  };

  return (
    <nav>
      {data.map((item: { id: any; name: string; link: string }, index: Key) => {
        return (
          <ul key={index}>
            <li>
              <NavLink to={item.link} id={item.id} onClick={handleLinkClick}>
                {item.name}
              </NavLink>
            </li>
          </ul>
        );
      })}
    </nav>
  );
}

export default NavbarProps;
